export default __webpack_public_path__ + "static/pp-1.0b.045b.html";